
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { store } from '../../../../../index';
import { reduxActions, RootState } from '../../../../../store'
import { IFile } from '../../../../../shared/interfaces';
import { DefaultButton, IButtonStyles } from '@fluentui/react';
import AppUtilities from '../../../../../shared/Utilities/appUtilities';
import filesService from '../../../../../services/files.service';
import { toastRef } from '../../../../Layout/Layout';


export interface FromFileProps {
    target: string
    onFileChanged?: () => void;
}
type Props = FromFileProps


const FromFile: React.FunctionComponent<Props> = props => {

    const selectCurrentProtocol = (state: RootState) => state.protocolWizardReducer.protocol;
    const currentProtocol = useSelector(selectCurrentProtocol);

    const uploadInputRef = useRef<HTMLInputElement>(null);
    const uploadButtonStyles: Partial<IButtonStyles> = {
        root: {
            marginTop: 15
        }

    }
    const onInputFileChange = (files) => {

        let filesList = props.target === 'documento' ? [files[0]] : [...files]

        filesList.forEach(file => {
            let originalFileName = file.name;
            let originalExtensionLowerCase = AppUtilities.getExtensionFromFilename(originalFileName);


            const docFile: IFile = {
                fileName: originalFileName,
                extension: originalExtensionLowerCase,
                fileType: "Documento",
                docBase64String: undefined,
                dimension: file.size,
                dimensionUnit: "B",
                enabled: true,
                file: file // Salva il File nativo del browser
            };

            switch (props.target) {
                case 'documento':
                    let extensionsIsAllowed = AppUtilities.extensionsAllowedForProtocolDocument.findIndex(el => el.toLowerCase() === originalExtensionLowerCase) >= 0;
                    if (originalExtensionLowerCase !== ".pdf" && extensionsIsAllowed) {
                        store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: { ...docFile, loading: true } }));

                        filesService.convertToPdf(file)
                            .then(result => {
                                let fileName = originalFileName;

                                if (originalExtensionLowerCase === ".p7m") {
                                    fileName = AppUtilities.extractOriginalFileNameFromP7M(fileName);

                                    // Aggiungi il p7m originale agli allegati
                                    if (currentProtocol?.attachments &&
                                        currentProtocol?.attachments?.findIndex(el => el.fileName === docFile.fileName) < 0) {
                                        store.dispatch(reduxActions.protocolWizardActions.addAttachment(docFile));
                                        toastRef.current?.show({
                                            severity: 'info',
                                            summary: "Informazione",
                                            detail: "Il file .p7m  \u00e8 stato aggiunto tra gli allegati",
                                            life: 5000
                                        });
                                    }
                                }
                                fileName = AppUtilities.replaceExtension(fileName, ".pdf");
                                let extension = ".pdf";

                                store.dispatch(reduxActions.protocolWizardActions.setProtocol({
                                    documentFile: {
                                        ...docFile,
                                        fileName,
                                        extension,
                                        docBase64String: undefined, // ? Non salviamo base64
                                        file: result, // ? Salviamo il File convertito
                                        loading: false
                                    }
                                }));

                                store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());

                                if (props.onFileChanged) {
                                    props.onFileChanged();
                                }
                            })
                            .catch(error => {
                                store.dispatch(reduxActions.protocolWizardActions.setProtocol({
                                    documentFile: undefined
                                }));

                                if (!error.isErrorShown) {
                                    toastRef.current?.show({
                                        severity: 'error',
                                        summary: "Attenzione",
                                        detail: "Non  \u00e8 stato possibile convertire il documento",
                                        life: 5000
                                    });
                                }
                            });
                    }
                    else if (originalExtensionLowerCase === '.pdf') {
                        store.dispatch(reduxActions.protocolWizardActions.setProtocol({
                            documentFile: {
                                ...docFile,
                                docBase64String: undefined, // ? Non salviamo base64
                                loading: false,
                                enabled: true
                            }
                        }));
                        store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                        if (props.onFileChanged) {
                            props.onFileChanged();
                        }
                    }
                    else {
                        toastRef.current?.show({
                            severity: 'warn',
                            summary: 'Attenzione',
                            detail: `Estensione del documento principale non consentita`,
                            life: 5000
                        });
                    }
                    break;

                case 'allegati':
                    if (currentProtocol?.attachments && currentProtocol?.attachments?.findIndex(el => el.fileName === docFile.fileName) < 0)
                        store.dispatch(reduxActions.protocolWizardActions.addAttachment(docFile));
                    store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                    if (props.onFileChanged) {
                        props.onFileChanged();
                    }

                    break;

            }
        });


        if (uploadInputRef && uploadInputRef.current) {
            uploadInputRef.current.value = '';
        }

    }
    const onUploadButtonClick = () => {
        if (uploadInputRef && uploadInputRef.current) {
            uploadInputRef.current.click();
        }
    };

    return (
        <React.Fragment>
            <input
                ref={uploadInputRef}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => onInputFileChange(e.target.files)}
                multiple={props.target === 'allegati'}
                accept={props.target === 'documento' ? AppUtilities.extensionsAllowedForProtocolDocument.join(',') : undefined}
            />

            <DefaultButton
                text="Upload file"
                onClick={onUploadButtonClick}
                allowDisabledFocus
                styles={uploadButtonStyles}
            />
        </ React.Fragment>
    )
};


export default FromFile;


